import styled, { css } from 'styled-components';
import { ReactComponent as Logo } from '../../assets/images/bimtrack-horizontal-logo.svg';

export const StyledLoginPage = {
  Container: styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ${({ theme: { colors } }) => css`
      background: ${colors.white};
    `};
  `,
  LogoIcon: styled(Logo)`
    flex-shrink: 0;
    ${({ theme: { metrics } }) => css`
      width: ${metrics.rem(480)};
      height: auto;
      margin-bottom: ${metrics.rem(50)};
    `}
  `,
};
